e4.news = {
    init: function () {
        e4.news.paging();
        if ( jQuery( '.js-e-news-filter' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'loop' );
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-news-list-handlebars-template' );
                e4.news.filter.init();
            } );
        }
    },
    filter: {
        timeout: null,
        init: function () {
            e4.news.filter.bindEvents();
            var yearToGet = jQuery( '#ambu-news-accordion' ).data( 'year-to-get' );
            var currentFilter = jQuery( '.js-e-news-filter-option[data-filter=".filter-' + yearToGet + '"]' );
            jQuery( currentFilter ).trigger('click');
            e4.news.restrictAccess.init();
        },
        bindEvents: function () {
            jQuery( '.js-e-news-filter' ).on( 'click', '.js-e-news-filter-option', function ( event ) {
                var yearFrom = jQuery( this ).data( 'news-year-from' );
                var yearTo = jQuery( this ).data( 'news-year-to' );
                event.preventDefault();
                e4.news.filter.toggleControls( this );
                e4.news.getNews.get( yearFrom, yearTo );
                e4.news.restrictAccess.init();
            } );
            if(e4.util.hash.get( 'ambu-news-item') === undefined){
            jQuery( '.js-e-news-filter' ).find( '.js-e-news-filter-option' ).first().trigger( 'click' );
            }
        },
        toggleControls: function ( domElm ) {
            var jThis = jQuery( domElm );
            jThis.addClass( 'active' );
            jThis.closest( '.js-e-news-filter' ).find( '.js-e-news-filter-option' ).not( jThis ).removeClass( 'active' );
        }
    },
    revealActive: function () {
        var strAmbuNewsItem = e4.util.hash.get( 'ambu-news-item' );
        if ( strAmbuNewsItem !== undefined ) {
            jAmbuNewsItem = jQuery( '.js-ambu-news-item-' + strAmbuNewsItem );
            if ( jAmbuNewsItem.length === 1 ) {
                jAmbuNewsItem.closest( '.e-section' ).addClass( e4.settings.scrollReveal.classResetAnimate );
                if ( jQuery( '.js-e-news-filter' ).length > 0 ) {
                    var arrAmbuNewsItemClasses = jAmbuNewsItem.attr( 'class' ).split( ' ' );
                    for ( var c = 0; c < arrAmbuNewsItemClasses.length; c++ ) {
                        if ( arrAmbuNewsItemClasses[ c ].indexOf( 'filter-' ) === 0 ) {
                            jQuery( '.js-e-news-filter-option[data-filter=".' + arrAmbuNewsItemClasses[ c ] + '"]' ).trigger( 'click' );
                        }
                    }
                }
                setTimeout( function () {
                    var intScrollTarget = 0;
                    intScrollTarget = jAmbuNewsItem.offset().top;
                    jQuery( e4.settings.scrollToAnchor.stickyElements ).each( function () {
                        intScrollTarget -= jQuery( this ).height();
                    } );
                    intScrollTarget -= jQuery( window ).height() / 100 * e4.settings.scrollToAnchor.nudge;
                    intScrollTarget = Math.max( intScrollTarget, 0 );
                    e4.scrollToAnchor.animate( intScrollTarget, function () {
                        jAmbuNewsItem.find( '.collapse' ).collapse( 'show' );
                    } );
                }, e4.settings.animation.speed );
            }
        }
    },
    paging: function () {
        var jNewsPaging = jQuery( '.js-e-news-pagination' );
        if ( jNewsPaging.length === 1 ) {
            jNewsPaging.find( 'a' ).not( '.js-e-news-pagination-item' ).addClass( 'page-link' );
            var jNewsPagingList = jQuery( '.js-e-news-pagination-list-dw' ).find( 'a' ),
                jNewsPagingItemTemplate = jQuery( '.js-e-news-pagination-item' ),
                jNewsPagingListNew = [];
            jNewsPagingList.each( function () {
                var jThis = jQuery( this ),
                    jNewsPagingItemNew = jNewsPagingItemTemplate.clone();
                jNewsPagingItemNew.find( 'a' ).attr( 'href', jThis.attr( 'href' ) ).text( jThis.text() );
                if ( jThis.find( 'b' ).length === 1 ) {
                    jNewsPagingItemNew.addClass( 'active' );
                }
                jNewsPagingListNew.push( jNewsPagingItemNew );
            } );
            jNewsPagingItemTemplate.replaceWith( jNewsPagingListNew );
        }
    },
    getNews: {
        get: function ( yearFrom, yearTo ) {
            var url = jQuery( '#ambu-news-accordion' ).data( 'news-json-url' );
            jQuery.ajax( {
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function () {
                        jQuery( '.js-e-news-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: {
                        yearFrom: yearFrom,
                        yearTo: yearTo
                    }
                } )
                .done( function ( data ) {
                    jQuery( '.js-e-news-loading-overlay' ).removeClass( 'is-loading' );
                    e4.news.getNews.build( data );
                } )
                .fail( function ( error ) {

                } );
        },
        build: function ( data ) {
            jQuery( '#ambu-news-accordion' ).html( e4.handlebars.tmpl.newsListHandlebarsTemplate( data ) );
            e4.news.revealActive();
            e4.news.restrictAccess.init();
            e4.news.sortNews.init();
        }
    },
    sortNews: {
        init: function () {
            jQuery(".js-e-news-filter li").sort(sort_li).appendTo('.js-e-news-filter');
            function sort_li(a, b){
                return (jQuery(b).data('year')) > (jQuery(a).data('year')) ? 1 : -1;
            }
        },
    },
    restrictAccess: {
        init: function () {

            var newsAccordion = jQuery( '#ambu-news-accordion' ),
                newsItem = jQuery( newsAccordion ).find( '.js-e-news-item' );
            
            jQuery( newsAccordion ).find( newsItem ).each( function ( ) {
                var newsContent = newsItem.find( '.js-ambu-access-restricted' ),
                    newsCheckbox = newsItem.find( '.js-ambu-checkbox-access-restricted' ),
                    newsDetails = newsItem.find( '.js-ambu-access-restricted-details' ),
                    newsAccessRestriction = newsContent.attr( 'data-restricted-access' );
            
                //console.log( 'Access Restricted: ' + getAccessRestriction );
                if ( newsAccessRestriction === 'true' ) {
                    newsItem.find( newsDetails ).addClass('hidden-xl-down');
                    jQuery( newsCheckbox ).change(function() {
                        if(this.checked) {
                            newsContent.attr( 'data-toggle', 'collapse' );
                            newsItem.find( newsDetails ).removeClass('hidden-xl-down');
                        } else {
                            newsContent.attr( 'data-toggle', '' );
                            newsItem.find( newsDetails ).addClass('hidden-xl-down');
                            newsItem.find( '.accordion-body' ).removeClass('in');
                        }
                    });
                } else {
                    newsContent.attr('data-restricted-access', 'false');
                }
            } );
        },
    }
};
